import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import AccountDetails from './AccountDetails';
import FundDetails from './FundDetails';
import '../css/SuperlifeLegacyPlan.css';
import "../css/BalanceByAccount.css";


class BBADetailsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs: "accounts",
        }
    }

    style = {
        backgroundColor: "#dedbde",
    }

    componentDidMount() {
        document.getElementsByClassName('balanceByAccountsFunds').item(0) && this.toggleBtwTabs(this.props.match.params.tab);
    }

    handleClick(e) {
        e.target.style.backgroundColor = "white";
        e.target.style.borderBottomColor = "white";
        this.toggleBtwTabs(e.target.id)
    }

    toggleBtwTabs(id) {
        if (id === "accounts") {
            document.getElementById("accounts").style.backgroundColor = "white";
            document.getElementById("accounts").style.borderBottomColor = "white";
            document.getElementById("accountsTab").style.marginLeft = "130px";
            document.getElementById("funds").style.borderBottomColor = "#c9c3ba";
            document.getElementById("funds").style.backgroundColor = this.style.backgroundColor;
        }
        if (id === "funds") {
            document.getElementById("accountsTab").style.marginLeft = "none";
            document.getElementById("funds").style.backgroundColor = "white";
            document.getElementById("funds").style.borderBottomColor = "white";
            document.getElementById("fundsTab").style.marginLeft = "275px";
            document.getElementById("accounts").style.borderBottomColor = "#c9c3ba";
            document.getElementById("accounts").style.backgroundColor = this.style.backgroundColor;
        }
    }

    handleChange(e) {
        console.log(e);

    }

    render() {
        const { t } = this.props
        return (
            <div className="balanceByAccountsFunds">
                <ul id="tabs" className="tabs">
                    <li><Link className="detailsTable" id="accounts" style={this.style} defaultChecked="true" to="accounts"
                        onClick={e => this.handleClick(e)}>{t('balanceDetails:accountDetails')}</Link></li>
                    <li style={{ paddingLeft: "135px" }}><Link className="detailsTable" id="funds" style={this.style} to="funds"
                        onClick={e => this.handleClick(e)}>{t('balanceDetails:fundDetails')}</Link></li>
                </ul>

                <div className="tabContent" id="accountsTab" style={{ display: "block" }}></div>
                <div className="tabContent" id="fundsTab" style={{ display: "none" }}></div>
                
                {
                   this.props.match.params.tab === "accounts" ? <AccountDetails {...this.props} />
                        : this.props.match.params.tab === "funds" ? <FundDetails {...this.props} />
                            : " "
                }
            </div>
        )
    }
}

export default withTranslation()(BBADetailsComponent);